
export const DocumentInputs = (listCategories: any) => ([
    {
        label: "Inserisci nome documento",
        name: 'nome',
        placeholder: "Inserisci nome documento",
        type: 'text',
        validators: {
            required: 'Il nome è obbligatorio'
        },
        type_input: 'input',
        size_input: 'w-full row-start-2',
    },
    {
        label: 'Inserisci testo personalizzato documento',
        name: 'descrizione',
        placeholder: 'Inserisci testo personalizzato documento',
        type: 'text',
        validators: {
            required: 'Il campo è obbligatorio'
        },
        type_input: 'text-area',
        size_input: 'w-full row-span-2 row-start-2 -mt-2',
        hfull: 'full'
    },
    {
        label: 'Categorie',
        name: 'categorieLavoratori',
        placeholder: 'Categorie',
        type: 'select',
        validators: {
            required: 'Il campo è obbligatorio'
        },
        type_input: 'react-select',
        size_input: 'w-full',
        options: listCategories,
        isMulti: true,
    },
])

export const fileInputDocument = (type: string) => ([
    {
        label: 'Seleziona file',
        name: 'document',
        placeholder: 'Seleziona file',
        type: 'file',
        validators: {
            required: type === 'add' ? 'Il campo è richiesto' : false,
            validate: {
                isPDF: (files: FileList) => {
                  if (files && files.length > 0) {
                    return validateFileType(files[0]);
                  }
                  return true;
                },
            },
        },
        type_input: 'file',
        size_input: 'w-full',
        class: "col-span-2",
        accept: "application/pdf"
    },
])


export const validateFileType = (file: File) => {
    if (file && file.type !== "application/pdf") {
      return "Il file deve essere un PDF.";
    }
    return true;
};